import resourceService from './resource-service.js';
import campaignService from './campaign-service.js';
import clientService from './client-service.js';
import customerService from './customer-service.js';
import orderService from './order-service.js';
import supportService from './support-service.js';
import authService from './auth-service.js';
import cartService from './cart-service.js';
import marketplaceService from './marketplace-service.js';
import userService from './user-service.js';
import productsService from './products-service.js';
import offersService from './offers-service.js';
import currencyService from './currency-service.js';
import cobrandedService from './cobranded-service.js';

export default angular.module('cui.apiServices', [])
  .service('ResourceService', resourceService)
  .service('CampaignService', campaignService)
  .service('ClientService', clientService)
  .service('CustomerService', customerService)
  .service('OrderService', orderService)
  .service('SupportService', supportService)
  .service('AuthService', authService)
  .service('CartAPIService', cartService)
  .service('MarketplaceService', marketplaceService)
  .service('UserService', userService)
  .service('ProductsService', productsService)
  .service('OffersService', offersService)
  .service('CurrencyAPIService', currencyService)
  .service('CobrandedAPISerice', cobrandedService)
  ;



// WEBPACK FOOTER //
// ./source/client/api-services/index.js